module.exports = __webpack_public_path__ + "static/greybunny3-bf6df7369f174b453ff19ba87bd586b0.png";